import { space100 } from '@ingka/variables'
import { Flex, FlexProps } from '@mantine/core'

type WidgetFooterProps = {
  children: React.ReactNode
} & FlexProps

const WidgetFooter: React.FC<WidgetFooterProps> = ({ children, ...flexProps }) => (
  <Flex wrap="wrap" gap={space100} mt={space100} {...flexProps}>
    {children}
  </Flex>
)

export default WidgetFooter
